var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXblanco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.3,
    height: 31.167,
    viewBox: "0 0 33.3 31.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "X_blanco",
    "data-name": "X blanco",
    transform: "translate(-445.186 1438.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(445.186 -1438.581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M-170.476-83.8h4.552l20.1,26.877h-4.552Zm-4.282-2.145L-161.9-68.756-174.84-54.779h2.912L-160.6-67.016l9.152,12.237h9.909l-13.58-18.158,12.043-13.01h-2.912l-10.432,11.27-8.429-11.27Z",
    transform: "translate(174.84 85.946)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXblanco);
export default __webpack_public_path__ + "static/media/Xblanco.e903de1339cbbf784e240ffbd61a6e87.svg";
export { ForwardRef as ReactComponent };